import { useCodatAuth } from "@codat/client-cookie-manager";
import { AxiosRequestConfig } from "axios";
import { Options, UseAxios, UseAxiosResult } from "axios-hooks";

import { ApiError } from "./shared";

export const useApiRequest = <
  TResponse,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TBody = any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TError extends ApiError = any
>(
  useAxios: UseAxios,
  serviceName: string,
  requestConfig: AxiosRequestConfig | string,
  options?: Options
): UseAxiosResult<TResponse, TBody, TError> => {
  const auth = useCodatAuth();

  const token = auth.userData?.access_token;

  const resolvedConfig: AxiosRequestConfig =
    typeof requestConfig === "object"
      ? {
          ...requestConfig,
          headers: {
            ...(requestConfig.headers || {}),
            ...(token ? { authorization: `Bearer ${token}` } : {}),
          },
        }
      : {
          url: requestConfig,
          headers: {
            authorization: token && `Bearer ${token}`,
          },
        };

  const result = useAxios<TResponse, TBody, TError>(resolvedConfig, options);

  const error = result[0].error;
  const data = error?.response?.data;
  const service = data?.service;

  if (error && data && service === serviceName) {
    const { statusCode } = data;

    if (statusCode === 401) {
      error.isAuthError = true;
      auth.signIn();
    }

    if (statusCode === 402 && data.error === "Payment Required") {
      error.isAuthError = true;
      auth.selectClient();
    }

    if (statusCode === 403) {
      error.isAuthError = true;
      auth.selectClient();
    }
  }

  return result;
};
